import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/home.vue')
  },{
    path: '/product',
    name: 'product',
    component: () => import('../views/product/product.vue')
  },{
    path: '/category/:category',
    name: 'category',
    component: () => import('../views/product/category.vue'),
    props: true
  },{
    path: '/category/:category/:productId',
    name: 'product-detail',
    component: () => import('../views/product/detail.vue'),
    props: true
  },{
    path: '/industry',
    name: 'industry',
    component: () => import('../views/industry/industry.vue')
  },{
    path: '/industry/:category/:desc',
    name: 'industry-detail',
    component: () => import('../views/industry/detail.vue'),
    props: true
  },{
    path: '/download',
    name: 'download',
    component: () => import('../views/download/download.vue')
  },{
    path: '/video',
    name: 'video',
    component: () => import('../views/download/video.vue')
  },{
    path: '/service',
    name: 'service',
    component: () => import('../views/download/service.vue')
  },{
    path: '/aboutus',
    name: 'aboutus',
    component: () => import('../views/aboutus/aboutus.vue')
  },{
    path: '/certificate',
    name: 'certificate',
    component: () => import('../views/aboutus/certificate.vue')
  },{
    path: '/sustainability',
    name: 'sustainability',
    component: () => import('../views/aboutus/sustainability.vue')
  },{
    path: '/news',
    name: 'news',
    component: () => import('../views/news/news.vue')
  },{
    path: '/news/:detail',
    name: 'news-detail',
    component: () => import('../views/news/detail.vue'),
    props: true
  },{
    path: '/contactus',
    name: 'contactus',
    component: () => import('../views/contactus/contactus.vue')
  },

]

const router = new VueRouter({
  routes
})

// 路由切换后滚动到页面顶部
router.afterEach((to, from) => {
  // 使用 nextTick 确保 DOM 更新完成后再滚动
  Vue.nextTick(() => {
    // 优先处理 document.body 的滚动
    if (document.body.scrollTop > 0) {
      document.body.scrollTop = 0
    }
    // 同时处理 document.documentElement 的滚动
    if (document.documentElement.scrollTop > 0) {
      document.documentElement.scrollTop = 0
    }
    // 处理 window 的滚动
    if (window.pageYOffset > 0) {
      window.scrollTo(0, 0)
    }
  })
})

export default router
